<template>
	<div class="basis-page-cls">
        <section class="basis-cls_table">
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList" />
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	props: ['row'],
	computed: {
        ...mapGetters([
			'userInfo',  
			'isShowPhone'
		])
    },
	data() {
		return {
            column: [
				{ label: '客户姓名', prop: 'customerName', minWidth: 120 },
				{
                    label: '手机号',
                    minWidth: 150,
                    render: (h, scope) => {
                        return <span>{this.isShowPhone ? scope.row.mobileNum : this.hiddenPhone(scope.row.mobileNum)}</span>
                    }
                },
				{ label: '导入失败原因', prop: 'errMsg', minWidth: 180 },
            ],
			listQuery: {
				pageSize: 10,
                pageNum: 1,
				customerBatchNo: '',
            },
			total: 0,
			list: [],
		}
    },
	created() {
		this.getList();
	},
	methods: {
		getList() {
			this.listQuery.customerBatchNo = this.row.customerBatchNo;
			this.$api.apiPostSmsSelectSmsImportDetail(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.list || [];
				this.total = parseInt(response.total);
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		}
    }
}
</script>